import { Controller } from '@hotwired/stimulus'
import { uniqueId } from 'lodash'

export default class extends Controller {
  static targets = [
    'container',
  ]

  initialize() {
    this.backgroundId = uniqueId('modal-background')
    this.BACKGROUND_HTML =
      `<div id="${this.backgroundId}" class="fixed top-0 left-0 w-full h-full" style="background-color: rgba(0, 0, 0, 0.8); z-index: 9998;"></div>`
  }

  disconnect(event) {
    this.close(event);
  }

  open = event => {
    event.preventDefault();
    event.target.blur();
    this.containerTarget.classList.remove('hidden');
    document.body.insertAdjacentHTML('beforeend', this.BACKGROUND_HTML);
  }

  close = event => {
    if (event) event.preventDefault();
    this.containerTarget.classList.add('hidden')
    const backdrop = document.querySelector(`#${this.backgroundId}`)
    if (backdrop) backdrop.remove()
  }

  closeBackground(event) {
    if (event.target === this.containerTarget) {
      this.close(event);
    }
  }

  closeWithKeyboard(event) {
    if (event.keyCode === 27 && !this.containerTarget.classList.contains('hidden')) {
      this.close(event);
    }
  }
}


